import { isBrandRefreshEnabled } from '../../../../shared/utilities/brandRefresh';

/** Brand-refresh nav UI only when REACT_APP_BRAND_REFRESH_ENABLED === 'true'. */
export const isNavigationBarBrandRefresh = () => isBrandRefreshEnabled();

/** data-region value only when brand refresh is on — keeps legacy DOM attrs unchanged. */
export const getNavRegionProps = () =>
  isBrandRefreshEnabled() ? 'navigation-bar' : undefined;

/** data-part value only when brand refresh is on — keeps legacy DOM attrs unchanged. */
export const getNavPartProps = (part) =>
  isBrandRefreshEnabled() ? part : undefined;

/** Homepage marker for NavigationBar_onHomepage styles when brand refresh is on. */
export const getNavHomepageProps = (isOnHomepage) =>
  isBrandRefreshEnabled() && isOnHomepage ? 'true' : undefined;

/** Desktop logo — brand-refresh-app-logo-new.svg when flag on, else legacy horizontal PNG. */
export const getDesktopLogo = (legacyLogo, brandRefreshLogo) =>
  isBrandRefreshEnabled() ? brandRefreshLogo : legacyLogo;

/** Mobile logo — brand-refresh-logo-new.svg when flag on, else legacy app-logo PNG. */
export const getMobileLogo = (legacyLogo, brandRefreshLogo) =>
  isBrandRefreshEnabled() ? brandRefreshLogo : legacyLogo;

/** Location pin — brand-refresh-location-pin.svg when flag on, else legacy pin. */
export const getLocationPinIcon = (legacyIcon, brandRefreshIcon) =>
  isBrandRefreshEnabled() ? brandRefreshIcon : legacyIcon;

/** Nav icon asset — brand-refresh SVG when flag on, else legacy. */
export const getNavIcon = (legacyIcon, brandRefreshIcon) =>
  isBrandRefreshEnabled() ? brandRefreshIcon : legacyIcon;
